import React, { useState } from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import formatTitle from "../common/formatTitle";
import Grid from "@material-ui/core/Grid";
// import TitreTexteCta from "../../common/TitreTexteCta";
import TitreTexteCta from "../common/TitreTexteCta";
import ValueProposalItem from "./valueProposalItem";
import ValueProposalItemMobile from "./valueProposalItemMobile";
import SeL from "./Safety_light.svg";
import SeD from "./Safety_dark.svg";
import FlL from "./Fluidity_light.svg";
import FlD from "./Fluidity_dark.svg";
import InL from "./Intelligence_light.svg";
import InD from "./Intelligence_dark.svg";
import EfL from "./Efficiency_light.svg";
import EfD from "./Efficiency_dark.svg";

const pictosD = [SeD, FlD, InD, EfD];
const pictosL = [SeL, FlL, InL, EfL];

const useStyles = makeStyles((theme) => ({
  regularRow: {
    padding: theme.layout.paddingRegular,
  },
  regularRowMobile: {
    padding: theme.layout.paddingRegularMobile,
  },
  enLight: {
    color: theme.palette.primary.light,
  },
  valueParag: {
    maxWidth: "80%",
    marginTop: theme.spacing(4),
  },
  squareContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  noMargin: {
    margin: 0,
  },
}));

const ValueProposal = ({ langKey, title, content, items, btnLabel }) => {
  const classes = useStyles();
  const [selected, setSelected] = useState(0);

  const handleMouseEnter = (e, index) => setSelected(index);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("lg"));
  return (
    <Grid
      item
      container
      direction="row"
      className={clsx({
        [classes.regularRow]: matches,
        [classes.regularRowMobile]: !matches,
      })}
      justify="space-between"
      alignItems={matches ? "flex-start" : "stretch"}
      spacing={matches ? 4 : 1}
    >
      <TitreTexteCta
        title={
          <>
            {formatTitle(title[0])}
            {title[1] && <br />}
            {title[1] &&  formatTitle(title[1])}
          </>
        }
        text={content}
        ctaUrl={`/${langKey}/contact`}
        buttonLabel={btnLabel}
        lg={5}
      />
      {matches && (
        <Grid item xs={12} lg={6}>
          <div className={classes.squareContainer}>
            <ValueProposalItem
              pictoD={pictosD[0]}
              pictoL={pictosL[0]}
              onMouseEnter={(e) => handleMouseEnter(e, 0)}
              selected={selected === 0}
              values={items[0]}
              mR
              mB
            />
            <ValueProposalItem
              pictoD={pictosD[1]}
              pictoL={pictosL[1]}
              onMouseEnter={(e) => handleMouseEnter(e, 1)}
              selected={selected === 1}
              values={items[1]}
              mL
              mB
            />
          </div>
          <div className={classes.squareContainer}>
            <ValueProposalItem
              pictoD={pictosD[2]}
              pictoL={pictosL[2]}
              onMouseEnter={(e) => handleMouseEnter(e, 2)}
              selected={selected === 2}
              values={items[2]}
              mR
              mB
            />
            <ValueProposalItem
              pictoD={pictosD[3]}
              pictoL={pictosL[3]}
              onMouseEnter={(e) => handleMouseEnter(e, 3)}
              selected={selected === 3}
              values={items[3]}
              mL
              mB
            />
          </div>
        </Grid>
      )}
      {!matches &&
        items.map((val, idx) => (
          <ValueProposalItemMobile
            values={val}
            pictoD={pictosD[idx]}
            key={idx}
          />
        ))}
    </Grid>
  );
};

export default ValueProposal;
